export default "__VITE_PUBLIC_ASSET__fb36f064__"